import React from "react";
import { graphColors } from "utils/styles";
import { Pie, PieChart, Tooltip, ResponsiveContainer } from "recharts";

const ANSWERED_BY_LABELS = {
  human: "Human",
  machine_end_beep: "Machine (Beep)",
  machine_end_silence: "Machine (Silence)",
  machine_end_other: "Machine (Other)",
  fax: "Fax",
  unknown: "Unknown"
};

const AnsweredByChart = ({ answeredByBreakdown }) => {
  if (!answeredByBreakdown || Object.keys(answeredByBreakdown).length === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">Answered By</h4>
        <div style={{ textAlign: "center", padding: "40px", color: "#888" }}>
          No answered by data available
        </div>
      </div>
    );
  }

  const data = Object.entries(answeredByBreakdown).map(([key, value], i) => ({
    label: ANSWERED_BY_LABELS[key] || key,
    value,
    fill: graphColors[i % graphColors.length]
  }));

  return (
    <div className="graph-container">
      <h4 className="graph-header">Answered By</h4>
      <ResponsiveContainer height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            isAnimationActive={false}
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
        {data.map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div style={{ width: "12px", height: "12px", backgroundColor: item.fill, borderRadius: "2px" }} />
            <span style={{ fontSize: "12px" }}>{item.label}: {item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnsweredByChart;
